import { Major } from '../../lib/types';
import { Button } from '../../components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuLabel,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '../../components/ui/dropdown-menu';
import { SelectItem } from '@nextui-org/react';
import { ChevronDown } from 'lucide-react';
import { useState } from 'react';

function FourYrPlan({ group }: { group: Major[] | undefined }) {
  function handleChange(id: number) {
    setSelectedTrack(
      group?.find((t: Major) => {
        return t.trackId === id;
      })!
    );
    window.open(
      `https://mynkuerp.nku.edu/nku/public_api/slcm/4year_plan/${id}/pdf`,
      '_blank'
    );
  }
  const [selectedTrack, setSelectedTrack] = useState<Major | null>(null);
  return (
    <div className="min-w-[10rem] lg:min-w-[20rem] mt-0 child:mt-0">
      {group?.length !== 0 && (
        <DropdownMenu>
          <DropdownMenuTrigger className="max-w-full md:w-[350px] bg-white text-black text-left py-2 px-4 rounded-md flex items-center justify-between border text-sm font-bold">
            <span className="truncate">
              {selectedTrack !== null
                ? selectedTrack.optTxt !== ''
                  ? selectedTrack.optTxt
                  : selectedTrack.opt2Txt
                : 'Four Year Plans'}
            </span>
            <ChevronDown className="ms-2" />
          </DropdownMenuTrigger>
          <DropdownMenuContent className="bg-white text-black w-11/12 md:w-[350px]">
            <DropdownMenuLabel>Four Year Plans</DropdownMenuLabel>
            <DropdownMenuSeparator />
            <DropdownMenuRadioGroup
              onValueChange={(trackId: string) => {
                handleChange(parseInt(trackId));
              }}
            >
              {group?.map((track: Major) => {
                return (
                  <DropdownMenuRadioItem
                    className="capitalize w-100 flex items-center justify-between px-2"
                    value={track.trackId.toString()}
                    key={track.trackId}
                  >
                    <span className="truncate pr-2">
                      {track.optTxt !== '' ? track.optTxt : track.opt2Txt}
                    </span>
                  </DropdownMenuRadioItem>
                );
              })}
            </DropdownMenuRadioGroup>
          </DropdownMenuContent>
        </DropdownMenu>
      )}
      {group?.length === 0 && (
        <Button
          variant="outline"
          className="capitalize min-w-[10rem] lg:min-w-[20rem]"
          disabled
        >
          No Four Year Plan
        </Button>
      )}
    </div>
  );
}

export default FourYrPlan;
